import React, { useMemo } from "react";

import { ButtonProps } from "react-bootstrap";

import ButtonSmall from "../ButtonSmall/ButtonSmall";
import Text from "../Text/Text";

interface Props extends ButtonProps {
  onClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  onSubmit: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  text: string;
  isActive: boolean;
}

const ConfirmSubmitButton: React.FC<Props> = ({
  variant,
  onClick,
  text,
  isActive,
  onSubmit,
  ...props
}) => {
  const handleOnClick = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    if (isActive === true) {
      onSubmit(e);
    } else {
      onClick(e);
    }
  };

  const textString = useMemo(
    () => (isActive === true ? "Confirm" : text),
    [isActive, text]
  );
  return (
    <ButtonSmall
      {...props}
      variant={isActive ? "outline" : variant}
      onClick={handleOnClick}
    >
      <Text size="md">{textString}</Text>
    </ButtonSmall>
  );
};

export default ConfirmSubmitButton;
